import { processAPIResponse } from '@/utils/request';
import { fetchPermissionListByCategoryRequest, fetchPermissionListByRoleRequest } from '@/services/api/role';

export default {
  namespace: 'roles',

  state: {
    permissionsGroupByCategory: {},
    permissionsGroupByRole: {}
  },

  effects: {

    * fetchPermissionListGroupByCategoryRequest({ }, { call, put, select }) {
      const { response, data } = yield call(fetchPermissionListByCategoryRequest, {});
      yield processAPIResponse({ response, data }, {
        * onSuccess(data) {
          yield put({
            type: 'setPermissionListGroupByCategory',
            payload: data
          })
        }
      })
    },
    * fetchPermissionGroupByRoleRequest({ }, { call, put }) {
      const { response, data } = yield call(fetchPermissionListByRoleRequest, {});
      yield processAPIResponse({ response, data }, {
        * onSuccess(data) {
          yield put({
            type: 'setPermissionListGroupByRole',
            payload: data
          })
        }
      })
    },
  },

  reducers: {
    setPermissionListGroupByCategory(state, action) {
      return {
        ...state,
        permissionsGroupByCategory: action.payload
      }
    },
    setPermissionListGroupByRole(state, action) {
      return {
        ...state,
        permissionsGroupByRole: action.payload
      }
    }
  }
};
